<template>
  <!-- (拟设)基金 - 个人类型表单面板(弹窗编辑/回显平铺 复用) -->
  <el-form
    ref="formRef"
    :model="form"
    :rules="rules"
    label-position="top"
    :disabled="isReadonly"
    :class="{ readOnlyStyle: isReadonly }"
    class="personalForm"
  >
    <div class="postType">
      <el-form-item>
        <el-radio-group v-model="form.positionHeld">
          <el-radio label="SHAREHOLDER">{{ $t("enroll.intitle.type01") }}</el-radio>
          <el-radio label="DIRECTOR">{{ $t("enroll.intitle.type02") }}</el-radio>
          <el-radio label="DIRECTOR_AND_SHAREHOLDER">{{ $t("enroll.intitle.type03") }}</el-radio>
        </el-radio-group>
      </el-form-item>
    </div>
    <el-row :gutter="20" class="pt22">
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.cardName')" prop="fullName" ref="fullName">
          <el-input v-model="form.fullName" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.nationality')" prop="nationality" ref="nationality">
          <el-select v-model="form.nationality" :placeholder="$t('common.placeholder.select')" filterable class="wdb100">
            <el-option v-for="item of globalFormatList('nationalityList')" :key="`pNat-${item.value}`" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.cardType')" prop="identificationType" ref="identificationType">
          <el-select v-model="form.identificationType" :placeholder="$t('common.placeholder.select')" class="wdb100">
            <el-option v-for="item of byCountryFormatList('identificationData')" :key="`pId-${item.value}`" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.cardNo')" prop="identificationNo" ref="identificationNo">
          <el-input v-model="form.identificationNo" :placeholder="$t('common.placeholder.enter')" v-regexFilter="$halfWidthRegex" class="wdb100"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.phone')" prop="phone" ref="phone">
          <prefix-phone v-model="form.phone" class="wdb100"></prefix-phone>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.email')" prop="email" ref="email">
          <el-input v-model="form.email" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.address')" prop="residentialAddress" ref="residentialAddress">
          <el-input v-model="form.residentialAddress" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.birthDate')" prop="birthDate" ref="birthDate">
          <el-date-picker
            v-model="form.birthDate"
            type="date"
            :placeholder="$t('common.placeholder.select')"
            value-format="yyyy-MM-dd"
            class="wdb100"
          ></el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          :label="$t('enroll.intitle.isNomineeShareholder')"
          prop="isNominatedShareholder"
          ref="isNominatedShareholder"
          v-if="form.positionHeld === 'SHAREHOLDER' || form.positionHeld === 'DIRECTOR_AND_SHAREHOLDER'"
        >
          <el-select v-model="form.isNominatedShareholder" :placeholder="$t('common.placeholder.select')" class="wdb100">
            <el-option :value="1" :label="$t('common.yes')"></el-option>
            <el-option :value="0" :label="$t('common.no')"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          :label="$t('enroll.intitle.isNomineeDirector')"
          prop="isNominatedDirector"
          ref="isNominatedDirector"
          v-if="form.positionHeld === 'DIRECTOR' || form.positionHeld === 'DIRECTOR_AND_SHAREHOLDER'"
        >
          <el-select v-model="form.isNominatedDirector" :placeholder="$t('common.placeholder.select')" class="wdb100">
            <el-option :value="1" :label="$t('common.yes')"></el-option>
            <el-option :value="0" :label="$t('common.no')"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          :label="$t('enroll.intitle.isTenderResignation')"
          prop="directorNeedResigned"
          ref="directorNeedResigned"
          v-if="applymentHasNomineeDirector && (form.positionHeld === 'DIRECTOR' || form.positionHeld === 'DIRECTOR_AND_SHAREHOLDER')"
        >
          <el-select v-model="form.directorNeedResigned" :placeholder="$t('common.placeholder.select')" class="wdb100">
            <el-option :value="1" :label="$t('common.yes')"></el-option>
            <el-option :value="0" :label="$t('common.no')"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.isHasPrcInland')" prop="isHoldShareOfPrcInland" ref="isHoldShareOfPrcInland">
          <el-select v-model="form.isHoldShareOfPrcInland" :placeholder="$t('common.placeholder.select')" @change="isHoldShareOfPrcInlandChange" class="wdb100">
            <el-option :value="1" :label="$t('common.yes')"></el-option>
            <el-option :value="0" :label="$t('common.no')"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="form.isHoldShareOfPrcInland">
        <el-form-item :label="$t('enroll.intitle.prcInlandName')" prop="holdShareOfPrcEntity" ref="holdShareOfPrcEntity">
          <el-input v-model="form.holdShareOfPrcEntity" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.theFundsName')" prop="fundsInfo" ref="fundsInfo">
          <el-select v-model="form.fundsInfo" multiple :placeholder="$t('common.placeholder.select')" class="wdb100" filterable value-key="fundName">
            <el-option v-for="(item, xb) in fundInfoList" :label="item.fundName" :key="`personalKey-${xb}`" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <!-- 股份信息表格 (非 DIRECTOR 时显示) -->
    <shares-table :value="form" @input="handleSharesInput" :fundInfoList="fundInfoList" :isReadonly="isReadonly" v-if="form.positionHeld !== 'DIRECTOR'" />
  </el-form>
</template>

<script>
import validatorMixin from "@/mixins/validatorMixin";
import SharesTable from "./SharesTable.vue";
import { validateFormLocation } from "@/utils/common";
import { mapState, mapGetters } from "vuex";

// 可选业务类型集合（用于判断字段是否必填）
const OPTIONAL_BUSINESS_TYPES = ["COMPREHENSIVE_CUSTOMIZED", "FUND_ADMIN_CUSTOMIZED"];

export default {
  name: "FundDirectorPersonalFormPanel",
  mixins: [validatorMixin],
  components: { SharesTable },
  props: {
    /** 表单数据对象(弹窗模式: personalForm; 回显模式: 股东/董事row) */
    form: { type: Object, required: true },
    /** 基金信息列表（供关联基金选择） */
    fundInfoList: { type: Array, default: () => [] },
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState("applyment", ["applymentDetail", "applymentHasNomineeDirector"]),
    ...mapGetters("constant", ["globalFormatList", "byCountryFormatList"]),
    /** 判断当前是否为可选字段模式（COMPREHENSIVE_CUSTOMIZED / FUND_ADMIN_CUSTOMIZED） */
    isOptionalField() {
      return OPTIONAL_BUSINESS_TYPES.includes(this.applymentDetail.businessType);
    },
    rules() {
      const opt = this.isOptionalField;
      return {
        fullName: [{ required: true, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
        nationality: [{ required: true, message: this.$t("common.placeholder.select"), trigger: "submit" }],
        identificationType: [{ required: true, message: this.$t("common.placeholder.select"), trigger: "submit" }],
        identificationNo: [{ required: true, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
        email: [
          { required: !opt, message: this.$t("common.placeholder.enter"), trigger: "submit" },
          { type: "email", message: this.$t("common.regular.email"), trigger: "submit" },
        ],
        phone: [{ required: !opt, validator: this.validatePhone, trigger: "submit" }],
        residentialAddress: [{ required: true, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
        birthDate: [{ required: !opt, validator: this.validateBirthday, trigger: "submit" }],
        isNominatedShareholder: [{ required: true, message: this.$t("common.placeholder.select"), trigger: "submit" }],
        isNominatedDirector: [{ required: true, message: this.$t("common.placeholder.select"), trigger: "submit" }],
        directorNeedResigned: [{ required: true, message: this.$t("common.placeholder.select"), trigger: "submit" }],
        isHoldShareOfPrcInland: [{ required: true, message: this.$t("common.placeholder.select"), trigger: "submit" }],
        holdShareOfPrcEntity: [{ required: true, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
        fundsInfo: [
          {
            required: true,
            type: "array",
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        information: [{ required: true, message: this.$t("common.placeholder.replenish"), trigger: "submit" }],
      };
    },
  },
  methods: {
    /** 清除校验状态(供父组件通过ref调用) */
    clearValidate() {
      this.$nextTick(() => {
        if (this.$refs.formRef) this.$refs.formRef.clearValidate();
      });
    },
    /** 供父组件触发表单校验 */
    validate(callback) {
      this.$refs.formRef.validate((valid, object) => {
        if (!valid) validateFormLocation(object, this.$refs.formRef);
        callback && callback(valid);
      });
    },
    /**
     * SharesTable 返回深拷贝后的新对象(仅 sharesInfo 变化)，
     * form 是 prop 不能整体替换，将变更同步回原对象以保持父组件引用
     */
    handleSharesInput(val) {
      if (!val) return;
      this.$set(this.form, "sharesInfo", val.sharesInfo || []);
    },
    // 是否在中国大陆公司持有股份 - change
    isHoldShareOfPrcInlandChange() {
      if (this.form.isHoldShareOfPrcInland === 0) this.$set(this.form, "holdShareOfPrcEntity", null);
    },
  },
};
</script>

<style lang="scss" scoped>
/* 表单项基础样式(与弹窗内展示保持一致) */
.personalForm ::v-deep {
  .el-form-item__label {
    line-height: 1em;
    padding: 0 0 8px;
  }
  .el-form-item {
    margin-bottom: 20px;
  }
  .el-radio {
    margin-right: 18px;
  }
  .el-radio:last-child {
    margin-right: 0;
  }
  .el-radio__label {
    padding-left: 5px;
  }
  /* 数字输入框 spinner 隐藏 */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    appearance: none !important;
  }
  input[type="number"] {
    appearance: textfield !important;
  }
}
.postType {
  width: 100%;
  height: 40px;
  background: #f4f8fe;
  padding: 0 20px;
}
.postType ::v-deep .el-form-item__content {
  line-height: 40px;
}
</style>
